import type {
  ConversationMessage,
  ConversationSendMessage,
} from '@quromedical/communication';
import type { ConversationSendTemplateMessage } from '@quromedical/communication/server';
import { trpcClient } from 'trpc';

export class CommunicationApi {
  public sendMessage = async (
    message: ConversationSendMessage,
  ): Promise<ConversationMessage> => {
    return await trpcClient.communication.conversation.sendMessage.mutate(
      message,
    );
  };

  public sendTemplateMessage = async (
    templateMessage: ConversationSendTemplateMessage,
  ): Promise<ConversationMessage> => {
    return await trpcClient.communication.conversation.sendTemplateMessage.mutate(
      templateMessage,
    );
  };
}
